import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { BasicStateTypes } from '../types/types';
import axios from 'axios';
import { ADMIN_BASE_URL, HEADERS } from '../utils/config';
import { AppSnackbar } from '../hooks/appSnackbar';

const initialState: BasicStateTypes = {
    loading: false,
    data: null,
    error: null,
};

export const locationCrud = createAsyncThunk(
  'location/locationCrud',
  async ({ method, data, slug, query }: { method: string, data: any, slug: string | null, query: string | null }) => {
    const searchParams = new URLSearchParams(window.location.search);
    const pageNo = searchParams.get("page")
    const keyword = searchParams.get("keyword")
    try {
      const config = {
        method: method,
        url: `${ADMIN_BASE_URL}/locations${slug ? `/${slug}`: ``}?${query ? `name=${query}`: keyword ? `name=${keyword}` : ``}${`&page=${pageNo || 1}`}`,
        headers: await HEADERS(),
        data: data,
      };
      const response = await axios(config);
      if(method === "POST"){
        AppSnackbar({type: 'success', message: 'Successfully created'})
      }else if(method === "PUT" || method === "PATCH"){
        AppSnackbar({type: 'success', message: 'Successfully updated'})
      }else if(method === "DELETE"){
        AppSnackbar({type: 'success', message: 'Successfully deleted'})
      }
      return response.data;
    } catch (error: any) {
      if(error.code === "ERR_BAD_REQUEST"){
        AppSnackbar({ type: 'error', message: 'Network error!' })
      }      
      throw new Error(error)
    }
  }
);

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(locationCrud.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(locationCrud.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;        
        state.data = action.payload;
      })
      .addCase(locationCrud.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
})

export default locationSlice.reducer